export default __webpack_public_path__ + "static/media/firstPainted.cdf52925.jpg";